import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { mergeProps, mergeRefs } from '@react-aria/utils';
import { useFormFieldContext } from '../../../FormField/hooks/useFormFieldContext.js';
import { useSelectContext } from '../../../Select/hooks/useSelectContext.js';
import { DropdownTrigger as DropdownTriggerMemo } from '../../../../../FormField/Dropdown/DropdownTrigger.js';

var LegacySelectTrigger = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useFormFieldContext = useFormFieldContext(),
    isDisabled = _useFormFieldContext.isDisabled,
    formFieldState = _useFormFieldContext.state;
  var _useSelectContext = useSelectContext(),
    triggerRef = _useSelectContext.triggerRef,
    triggerProps = _useSelectContext.triggerProps,
    state = _useSelectContext.state;
  var mergedTriggerProps = mergeProps(props, triggerProps, state !== null && state !== void 0 && state.isOpen ? {
    'data-pressed': true
  } : {});
  var mergedRef = React.useMemo(function () {
    return mergeRefs(triggerRef, ref);
  }, [triggerRef, ref]);
  return /*#__PURE__*/React.createElement(DropdownTriggerMemo, _extends({
    ref: mergedRef,
    state: isDisabled ? 'disabled' : 'enabled',
    intent: formFieldState,
    "aria-label": props.label
  }, mergedTriggerProps));
});
var LegacySelectTriggerMemoized = /*#__PURE__*/React.memo(LegacySelectTrigger);
LegacySelectTriggerMemoized.displayName = 'LegacySelectTrigger';

export { LegacySelectTriggerMemoized as LegacySelectTrigger };
//# sourceMappingURL=LegacySelectTrigger.js.map
